import $ from 'jquery';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

const masonryOptions = {
  itemSelector: '.articles__brick',
  gutter: '.articles__gutter-sizer',
  columnWidth: '.articles__brick-sizer',
  percentPosition: true,
};

const masonries = {};

function initializeArticleMasonry() {
  const grid = document.querySelectorAll('.articles');
  for (let i = 0, len = grid.length; i < len; i += 1) {
    imagesLoaded(grid[i], function() {
      //console.log("Images loaded!")
      setTimeout(function() {
        masonries[i] = new Masonry(grid[i], masonryOptions);
      }, 50);
    });

    /*
    masonries[i] = {
      element: grid[i],
      imgload: imagesLoaded(grid[i]),
      masonry: new Masonry(grid[i], masonryOptions),
    }

    masonries[i].imgload.on('progress', () => {
      // Re-run layout when images are loaded
      masonries[i].masonry.layout()
    })
  */
  }
}

export default initializeArticleMasonry;
